import styled from 'styled-components'

export const SearchContainer = styled.div`
  min-height: 180px;
`
